import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=6f1e981f&scoped=true"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"
import style0 from "./Insight.vue?vue&type=style&index=0&id=6f1e981f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e981f",
  null
  
)

export default component.exports